<template>
  <div class="home">
    <navbar :is-active="5"></navbar>
    <div class="body">
      <div class="body__sidebar" id="body__sidebar">
        <div class="nav-mob-resp">
        <hidden-arrow></hidden-arrow>
        <div class="title">
          <div class="title__icon">
            <i class="fas fa-home"></i>
          </div>
          <div class="title__text">
            <h2>{{ company_name }}</h2>
            <p>Selecciona una opción</p>
          </div>
        </div>
        <div class="tabs">
          <router-link to="/Client/id-productos" class="tab">
            <div class="tab__icon">
              <i class="fab fa-product-hunt"></i>
            </div>
            <div class="tab__text">
              <p>Productos</p>
            </div>
          </router-link>
          <router-link to="/Client/id-clientes" class="tab">
            <div class="tab__icon">
              <i class="fas fa-user-friends"></i>
            </div>
            <div class="tab__text">
              <p>Clientes</p>
            </div>
          </router-link>
          <router-link to="/Client/id-ventas" class="tab">
            <div class="tab__icon">
              <i class="fas fa-file-invoice-dollar"></i>
            </div>
            <div class="tab__text">
              <p>Ventas</p>
            </div>
          </router-link>
          <router-link to="/Client/id-sucursales" class="tab">
            <div class="tab__icon">
              <i class="fas fa-shopping-cart"></i>
            </div>
            <div class="tab__text">
              <p>Sucursales</p>
            </div>
          </router-link>
          <router-link to="/Client/id-mapa-validacion" class="tab active">
            <div class="tab__icon">
              <i class="fas fa-map-marked-alt"></i>
            </div>
            <div class="tab__text">
              <p>Mapa de Validación</p>
            </div>
          </router-link>
        </div>
        </div>
      </div>
      <div class="body__containt mapa-dashboard">
        <div class="mapa-topbar">
          <open-arrow></open-arrow>
          <div class="mapa-filtros">
            <div class="mapa-filtros__contexto">
              <span class="mapa-filtros__empresa">{{ company_name }}</span>
              <span class="mapa-filtros__sep">·</span>
              <span class="mapa-filtros__sucursal">{{ sucursalActivaLabel }}</span>
            </div>
            <label class="mapa-filtros__select-wrap">
              <span class="mapa-filtros__select-label">Sucursal</span>
              <select
                v-model="sucursalSeleccionada"
                class="mapa-filtros__select"
                @change="fetchMapaValidacion"
              >
                <option value="">Todas las sucursales</option>
                <option
                  v-for="suc in sucursales"
                  :key="suc.id"
                  :value="String(suc.id)"
                >
                  {{ suc.branch_code }} — {{ suc.branch_name }}
                </option>
              </select>
            </label>
          </div>
        </div>

        <p v-if="errorMapa" class="mapa-error" role="alert">{{ errorMapa }}</p>

        <section class="summary-cards" aria-label="Resumen por estado">
          <div class="stat-card stat-card--paid">
            <div class="stat-card__icon" aria-hidden="true">
              <i class="fas fa-shopping-bag"></i>
            </div>
            <span class="stat-card__label">Usuarios Comprando: {{ cuentaComprando }}</span>
          </div>
          <div class="stat-card stat-card--pending">
            <div class="stat-card__icon" aria-hidden="true">
              <i class="fas fa-exclamation-circle"></i>
            </div>
            <span class="stat-card__label">Pendiente de Validar: {{ cuentaPendientes }}</span>
          </div>
          <div class="stat-card stat-card--done">
            <div class="stat-card__icon" aria-hidden="true">
              <i class="fas fa-check-circle"></i>
            </div>
            <span class="stat-card__label">Cliente Validado: {{ cuentaValidados }}</span>
          </div>
        </section>

        <section class="mapa-section" aria-label="Plano de tienda">
          <div class="store-map-wrap">
            <div class="store-map" role="img" aria-label="Distribución interna tipo tienda vista desde arriba">
              <div class="store-map__floor">
                <div class="store-map__stage">
                  <div class="store-map__plot">
                  <div
                    class="store-grid"
                    :style="{ '--cols': gridCols, '--rows': gridRows }"
                  >
                    <template v-for="(b, i) in bloquesPlano" :key="'blk-' + i">
                      <div
                        v-if="b.type === 'shelf'"
                        class="store-block store-shelf"
                        :class="'store-shelf--' + b.section"
                        :style="gridSpan(b)"
                      >
                        <span class="store-shelf__texture" aria-hidden="true"></span>
                      </div>
                      <div
                        v-else-if="b.type === 'aisle'"
                        class="store-block store-aisle"
                        :style="gridSpan(b)"
                        aria-hidden="true"
                      ></div>
                      <div
                        v-else-if="b.type === 'checkout'"
                        class="store-block store-checkout"
                        :style="gridSpan(b)"
                      >
                        <span class="store-checkout__label">Cajas</span>
                        <div class="store-checkout__lanes" aria-hidden="true">
                          <span v-for="n in 3" :key="'ln-' + n" class="store-checkout__lane"></span>
                        </div>
                      </div>
                      <div
                        v-else
                        class="store-block store-entrance"
                        :style="gridSpan(b)"
                      >
                        <span class="store-entrance__doors" aria-hidden="true"></span>
                        <span class="store-entrance__label">Entrada / Salida</span>
                      </div>
                    </template>
                  </div>
                  <div class="store-points">
                    <span
                      v-for="(p, idx) in puntosMapa"
                      :key="'pt-' + idx"
                      class="store-point"
                      :class="'store-point--' + p.color"
                      :style="{ left: p.x + '%', top: p.y + '%' }"
                      :title="p.label || 'Punto en pasillo'"
                    />
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="listas-clientes" aria-label="Listado de clientes por estado">
          <div class="lista-col lista-col--paid">
            <h3 class="lista-col__title">Usuarios Comprando</h3>
            <ul class="lista-col__ul">
              <li v-for="(cliente, i) in clientesComprando" :key="'p-' + cliente.id">
                <span class="lista-col__dot lista-col__dot--paid" aria-hidden="true"></span>
                Cliente {{ i + 1 }}: {{ cliente.nombre || 'Sin nombre' }}<template v-if="mostrarSucursalEnLista"> · {{ cliente.sucursal }}</template>
              </li>
              <li v-if="!cargando && clientesComprando.length === 0" class="lista-col__empty">
                No hay usuarios comprando
              </li>
            </ul>
          </div>
          <div class="lista-col lista-col--pending">
            <h3 class="lista-col__title">Pendientes de Validar</h3>
            <ul class="lista-col__ul">
              <li v-for="(cliente, i) in clientesPendientes" :key="'pe-' + cliente.id">
                <span class="lista-col__dot lista-col__dot--pending" aria-hidden="true"></span>
                Cliente {{ i + 1 }}: {{ cliente.nombre || 'Sin nombre' }}<template v-if="mostrarSucursalEnLista"> · {{ cliente.sucursal }}</template>
              </li>
              <li v-if="!cargando && clientesPendientes.length === 0" class="lista-col__empty">
                No hay pendientes de validar
              </li>
            </ul>
          </div>
          <div class="lista-col lista-col--done">
            <h3 class="lista-col__title">Clientes Validados</h3>
            <ul class="lista-col__ul">
              <li v-for="(cliente, i) in clientesValidados" :key="'v-' + cliente.id">
                <span class="lista-col__dot lista-col__dot--done" aria-hidden="true"></span>
                Cliente {{ i + 1 }}: {{ cliente.nombre || 'Sin nombre' }}<template v-if="mostrarSucursalEnLista"> · {{ cliente.sucursal }}</template>
              </li>
              <li v-if="!cargando && clientesValidados.length === 0" class="lista-col__empty">
                No hay clientes validados
              </li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Navbar from '@/components/NavBar'
  import OpenArrow from '@/components/OpenArrow.vue'
  import HiddenArrow from '@/components/HiddenArrow.vue'

  export default {
    name: 'IDMapaValidacion',
    components: {
      Navbar,
      OpenArrow,
      HiddenArrow
    },
    data() {
      return {
        company_name: localStorage.getItem('company_name'),
        clientesComprando: [],
        clientesPendientes: [],
        clientesValidados: [],
        cargando: false,
        errorMapa: '',
        sucursales: [],
        sucursalSeleccionada: '',
        /** 23 columnas: cajas + pasillos + 5 estantes (sin pasillo derecho final) */
        gridCols: 23,
        gridRows: 10,
        /**
         * Líneas de grid 1-based (fin exclusivo). Pasillos `aisle` separan estantes (no se tocan).
         */
        bloquesPlano: [
          { type: 'checkout', cs: 1, ce: 3, rs: 2, re: 10 },
          { type: 'aisle', cs: 3, ce: 5, rs: 2, re: 8 },
          { type: 'shelf', cs: 5, ce: 7, rs: 2, re: 8, section: 'yellow' },
          { type: 'aisle', cs: 7, ce: 9, rs: 2, re: 8 },
          { type: 'shelf', cs: 9, ce: 11, rs: 2, re: 8, section: 'red' },
          { type: 'aisle', cs: 11, ce: 13, rs: 2, re: 8 },
          { type: 'shelf', cs: 13, ce: 15, rs: 2, re: 8, section: 'green' },
          { type: 'aisle', cs: 15, ce: 17, rs: 2, re: 8 },
          { type: 'shelf', cs: 17, ce: 19, rs: 2, re: 8, section: 'yellow' },
          { type: 'aisle', cs: 19, ce: 21, rs: 2, re: 8 },
          { type: 'entrance', cs: 8, ce: 19, rs: 9, re: 11 }
        ],
        /** Color + etiqueta; la posición se calcula en el centro de cada pasillo */
        puntosClientes: [
          { color: 'yellow', label: 'Javier Torres' },
          { color: 'red', label: 'Carlos Ruiz' },
          { color: 'green', label: 'Laura Gómez' },
          { color: 'yellow', label: 'Elena Muñoz' },
          { color: 'red', label: 'Sofía Morales' },
          { color: 'green', label: 'Ana Castillo' }
        ]
      }
    },
    computed: {
      cuentaComprando() {
        return this.clientesComprando.length
      },
      cuentaPendientes() {
        return this.clientesPendientes.length
      },
      cuentaValidados() {
        return this.clientesValidados.length
      },
      sucursalActivaLabel() {
        if (!this.sucursalSeleccionada) {
          return 'Todas las sucursales'
        }
        const suc = this.sucursales.find(
          (s) => String(s.id) === String(this.sucursalSeleccionada)
        )
        if (suc) {
          return `${suc.branch_code} — ${suc.branch_name}`
        }
        return 'Sucursal seleccionada'
      },
      mostrarSucursalEnLista() {
        return !this.sucursalSeleccionada
      },
      /** Centros horizontales de cada pasillo + leve variación en Y (siempre fuera de estantes) */
      puntosMapa() {
        const G = this.gridCols
        const R = this.gridRows
        const pasillos = this.bloquesPlano.filter((b) => b.type === 'aisle')
        const personas = this.puntosClientes
        const yBase = ((2 + 8 - 2) / (2 * R)) * 100
        return pasillos.slice(0, personas.length).map((a, i) => {
          const x = ((a.cs + a.ce - 2) / (2 * G)) * 100
          const y = yBase + ((i % 3) - 1) * 4.5
          return {
            x,
            y,
            color: personas[i].color,
            label: personas[i].label
          }
        })
      }
    },
    mounted() {
      if (localStorage.getItem('token')) {
        this.company_name = localStorage.getItem('company_name')
        this.fetchSucursales().then(() => this.fetchMapaValidacion())
      } else {
        this.$router.push('/login')
      }
    },
    methods: {
      fetchSucursales() {
        const companyId = localStorage.getItem('company_id')
        return axios.get('general/branchoffice', {
          params: {
            page: 1,
            branch_company_id: companyId
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }).then((res) => {
          if (res.data.data && res.data.data.data) {
            this.sucursales = res.data.data.data
          }
        }).catch(() => {
          this.sucursales = []
        })
      },
      fetchMapaValidacion() {
        this.cargando = true
        this.errorMapa = ''
        const companyId = localStorage.getItem('company_id')
        const data = {
          company_id: companyId ? parseInt(companyId, 10) : null
        }
        if (this.sucursalSeleccionada) {
          data.branch_office_id = parseInt(this.sucursalSeleccionada, 10)
        }
        axios.post('general/indicator/mapa-validacion', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }).then((res) => {
          if (res.data && res.data.data) {
            this.clientesComprando = res.data.data.comprando || []
            this.clientesPendientes = res.data.data.pendientes || []
            this.clientesValidados = res.data.data.validados || []
          } else {
            this.errorMapa = 'La API no devolvió datos. Revisa la consola de red (Network).'
          }
        }).catch((err) => {
          this.clientesComprando = []
          this.clientesPendientes = []
          this.clientesValidados = []
          const status = err.response && err.response.status
          const msg = err.response && err.response.data && err.response.data.message
          if (status === 401) {
            this.errorMapa = 'Sesión expirada. Cierra sesión y vuelve a entrar.'
          } else if (msg) {
            this.errorMapa = `Error al cargar el mapa: ${msg}`
          } else {
            this.errorMapa = `No se pudo conectar con la API (${axios.defaults.baseURL}). ¿Está corriendo quickpay.local?`
          }
        }).finally(() => {
          this.cargando = false
        })
      },
      gridSpan(b) {
        return {
          gridColumn: `${b.cs} / ${b.ce}`,
          gridRow: `${b.rs} / ${b.re}`
        }
      }
    }
  }
</script>

<style scoped>
  .home {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    font-family: 'Readex Pro', sans-serif;
  }

  .body {
    width: 100%;
    min-height: 0;
    flex: 1;
    display: flex;
  }

  .body__sidebar,
  .body__containt {
    min-height: 0;
    height: calc(100vh - 120px);
    box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
  }

  .body__sidebar {
    width: 400px;
    position: relative;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }

  .body__sidebar .title {
    width: 100%;
    height: 140px;
    border-bottom: 1px solid #b6b6b6;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .body__sidebar .title__icon {
    color: #ff3128;
    font-size: 20px;
  }

  .body__sidebar .title__text {
    margin: 0 10px;
  }

  .body__sidebar .title__text h2 {
    font-size: 20px;
    margin: 0;
  }

  .body__sidebar .title__text p {
    margin: 0;
    font-weight: 300;
  }

  .body__sidebar .tabs {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: calc(100% - 140px);
    padding-top: 5px;
    overflow-y: auto;
  }

  .body__sidebar .tabs .tab {
    width: 90%;
    height: 70px;
    border-radius: 10px;
    color: #707070;
    display: flex;
    align-items: center;
    padding: 0 20px;
    margin-bottom: 10px;
    cursor: pointer;
    transition: 0.3s ease;
    flex-shrink: 0;
  }

  .body__sidebar .tabs .tab:hover,
  .body__sidebar .tabs .tab.active {
    color: #ff3128;
    background: #ffeeed;
  }

  .body__sidebar .tabs .tab__icon {
    font-size: 20px;
    margin-right: 10px;
  }

  .body__sidebar .tabs .tab__text p {
    margin: 0;
    font-weight: 600;
  }

  .body__containt.mapa-dashboard {
    --mapa-paid: #f1b418;
    --mapa-pending: #e64a2e;
    --mapa-done: #5cb85c;
    --mapa-surface: #ffffff;
    --mapa-text: #262626;
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 16px 24px 28px;
    overflow-y: auto;
    background: var(--mapa-surface);
  }

  .mapa-topbar {
    flex-shrink: 0;
    margin-bottom: 4px;
    max-width: 1100px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
  }

  .mapa-filtros {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
    margin-left: auto;
  }

  .mapa-filtros__contexto {
    font-size: 0.9rem;
    color: #64748b;
  }

  .mapa-filtros__empresa {
    font-weight: 600;
    color: #334155;
  }

  .mapa-filtros__sep {
    margin: 0 6px;
  }

  .mapa-filtros__sucursal {
    color: #ff3128;
    font-weight: 500;
  }

  .mapa-filtros__select-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .mapa-filtros__select-label {
    font-size: 0.85rem;
    color: #64748b;
    white-space: nowrap;
  }

  .mapa-filtros__select {
    min-width: 220px;
    padding: 8px 12px;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    background: #fff;
    font-size: 0.9rem;
    color: #334155;
  }

  .mapa-error {
    max-width: 1100px;
    margin: 0 auto 12px;
    padding: 10px 14px;
    border-radius: 10px;
    background: #fef2f2;
    border: 1px solid #fecaca;
    color: #b91c1c;
    font-size: 0.9rem;
  }

  .summary-cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
    margin-bottom: 20px;
    max-width: 1100px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  .stat-card {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    border-radius: 12px;
    font-weight: 600;
    font-size: 0.95rem;
    color: var(--mapa-text);
    border: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  .stat-card__icon {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.25rem;
    flex-shrink: 0;
    color: #fff;
  }

  .stat-card--paid {
    background: linear-gradient(135deg, #fff7df 0%, #ffffff 100%);
  }

  .stat-card--paid .stat-card__icon {
    background: var(--mapa-paid);
  }

  .stat-card--pending {
    background: linear-gradient(135deg, #ffeae7 0%, #ffffff 100%);
  }

  .stat-card--pending .stat-card__icon {
    background: var(--mapa-pending);
  }

  .stat-card--done {
    background: linear-gradient(135deg, #eaf8ea 0%, #ffffff 100%);
  }

  .stat-card--done .stat-card__icon {
    background: var(--mapa-done);
  }

  .mapa-section {
    margin-bottom: 22px;
  }

  /* —— Mapa tipo supermercado (Grid + overlay puntos) —— */
  .store-map-wrap {
    max-width: 1100px;
    margin: 0 auto;
    width: 100%;
  }

  .store-map {
    border-radius: 16px;
    overflow: hidden;
    border: 1px solid #f0d7d6;
    box-shadow:
      0 16px 40px rgba(15, 23, 42, 0.1),
      0 0 0 1px rgba(255, 255, 255, 0.8) inset;
    background: linear-gradient(180deg, #fff8f8 0%, #fff2f1 100%);
  }

  .store-map__floor {
    position: relative;
    padding-top: clamp(14px, 2.5vw, 26px);
    padding-bottom: clamp(14px, 2.5vw, 28px);
    padding-left: clamp(16px, 4vw, 40px);
    padding-right: clamp(16px, 4vw, 40px);
    min-height: 280px;
  }

  .store-map__stage {
    position: relative;
    width: 100%;
  }

  /* Hueco lateral real: el grid ya no ocupa el 100% del ancho útil */
  .store-map__plot {
    position: relative;
    width: min(calc(100% - 2 * clamp(20px, 6vw, 72px)), 860px);
    margin-left: auto;
    margin-right: auto;
  }

  .store-grid {
    --cols: 23;
    --rows: 10;
    display: grid;
    grid-template-columns: repeat(var(--cols, 23), 1fr);
    grid-template-rows: repeat(var(--rows, 10), minmax(0, 1fr));
    gap: clamp(10px, 2vw, 18px);
    aspect-ratio: 23 / 10;
    max-height: min(52vh, 520px);
    margin: 0 auto;
    padding: 40px;
    background: linear-gradient(165deg, #fff6f5 0%, #ffeceb 100%);
    border-radius: 14px;
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.9),
      0 4px 20px rgba(15, 23, 42, 0.08);
    border: 1px solid rgba(255, 49, 40, 0.2);
  }

  .store-block {
    border-radius: 10px;
    box-shadow:
      0 4px 14px rgba(15, 23, 42, 0.12),
      inset 0 1px 0 rgba(255, 255, 255, 0.35);
    border: 1px solid rgba(0, 0, 0, 0.06);
    min-height: 0;
    min-width: 0;
  }

  /* Pasillo entre estantes (sin mobiliario) */
  .store-aisle {
    border-radius: 0;
    border: none;
    background: transparent;
    box-shadow: none;
  }

  /* Estanterías por sección (amarillo / rojo / verde) */
  .store-shelf {
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .store-shelf--yellow {
    background: linear-gradient(145deg, #fde047 0%, #facc15 40%, #eab308 100%);
    border-color: rgba(161, 98, 7, 0.35);
  }

  .store-shelf--red {
    background: linear-gradient(145deg, #fb7185 0%, #f43f5e 45%, #e11d48 100%);
    border-color: rgba(159, 18, 57, 0.35);
  }

  .store-shelf--green {
    background: linear-gradient(145deg, #4ade80 0%, #22c55e 45%, #16a34a 100%);
    border-color: rgba(21, 128, 61, 0.35);
  }

  .store-shelf__texture {
    position: absolute;
    inset: 6px;
    border-radius: 6px;
    opacity: 0.55;
    pointer-events: none;
    background-image: repeating-linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.22) 0 2px,
      transparent 2px 9px
    );
  }

  /* Checkout */
  .store-checkout {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 6px;
    background: linear-gradient(160deg, #64748b 0%, #475569 50%, #334155 100%);
    border-color: rgba(30, 41, 59, 0.5);
  }

  .store-checkout__label {
    font-size: clamp(0.55rem, 1.4vw, 0.72rem);
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(248, 250, 252, 0.95);
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);
  }

  .store-checkout__lanes {
    display: flex;
    gap: 4px;
    width: 100%;
    justify-content: center;
  }

  .store-checkout__lane {
    flex: 1;
    height: clamp(18px, 4vw, 28px);
    max-width: 28%;
    border-radius: 6px;
    background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%);
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  /* Entrada / salida */
  .store-entrance {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 4px;
    background: linear-gradient(180deg, #e0f2fe 0%, #bae6fd 50%, #7dd3fc 100%);
    border-color: rgba(3, 105, 161, 0.35);
  }

  .store-entrance__doors {
    width: 72%;
    height: 8px;
    border-radius: 4px;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.85) 0%, rgba(186, 230, 253, 0.5) 100%);
    box-shadow: inset 0 0 0 1px rgba(14, 116, 144, 0.25);
  }

  .store-entrance__label {
    font-size: clamp(0.5rem, 1.2vw, 0.65rem);
    font-weight: 700;
    color: #0c4a6e;
    text-align: center;
    line-height: 1.2;
  }

  /* Puntos: mismo rectángulo que el grid (dentro de .store-map__plot) */
  .store-points {
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 2;
  }

  .store-point {
    position: absolute;
    width: clamp(11px, 2.4vw, 16px);
    height: clamp(11px, 2.4vw, 16px);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    border: 2px solid #fff;
    box-shadow:
      0 2px 8px rgba(0, 0, 0, 0.25),
      0 0 0 1px rgba(0, 0, 0, 0.08);
  }

  .store-point--yellow {
    background: #facc15;
  }

  .store-point--red {
    background: #f43f5e;
  }

  .store-point--green {
    background: #22c55e;
  }

  .listas-clientes {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    max-width: 1100px;
    margin: 0 auto;
    width: 100%;
  }

  .lista-col {
    border-radius: 12px;
    padding: 16px 18px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    background: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  }

  .lista-col__title {
    margin: 0 0 12px;
    font-size: 1rem;
    font-weight: 700;
    padding-bottom: 10px;
    border-bottom: 2px solid;
  }

  .lista-col--paid .lista-col__title {
    color: #b8860b;
    border-color: var(--mapa-paid);
  }

  .lista-col--pending .lista-col__title {
    color: #c43d2a;
    border-color: var(--mapa-pending);
  }

  .lista-col--done .lista-col__title {
    color: #3d8b40;
    border-color: var(--mapa-done);
  }

  .lista-col__ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .lista-col__ul li {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-size: 0.9rem;
    color: var(--mapa-text);
    line-height: 1.45;
    margin-bottom: 10px;
  }

  .lista-col__ul li:last-child {
    margin-bottom: 0;
  }

  .lista-col__empty {
    font-style: italic;
    color: #94a3b8;
  }

  .lista-col__dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-top: 5px;
    flex-shrink: 0;
  }

  .lista-col__dot--paid {
    background: var(--mapa-paid);
  }

  .lista-col__dot--pending {
    background: var(--mapa-pending);
  }

  .lista-col__dot--done {
    background: var(--mapa-done);
  }

  .body__sidebar.open {
    display: none;
  }

  @media (max-width: 1024px) {
    .summary-cards,
    .listas-clientes {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 768px) {
    .body {
      flex-direction: column;
    }

    .body__sidebar,
    .body__containt {
      height: auto;
      min-height: auto;
    }

    .body__sidebar .title__text h2 {
      font-size: 18px;
    }

    .body__sidebar .tabs .tab__icon {
      color: white;
    }

    .body__sidebar .tabs .tab:hover,
    .body__sidebar .tabs .tab.active svg {
      color: #ff3128;
    }

    .body__sidebar .tabs .tab:hover,
    .body__sidebar .tabs .tab.active p {
      color: #ff3128;
      font-size: 20px;
    }

    .body__sidebar .tabs .tab__text p {
      color: white;
      font-size: 18px;
    }

    .body__sidebar .tabs .tab:hover,
    .body__sidebar .tabs .tab.active {
      background: #262626;
    }

    .home .body .nav-mob-resp {
      position: absolute;
      background: #262626;
      height: 85vh;
      width: 25vh;
    }

    .body__sidebar .title {
      color: white;
    }

    .body__containt.mapa-dashboard {
      padding: 12px 14px 24px;
    }

    .store-map__floor {
      padding-top: 12px;
      padding-bottom: 12px;
      padding-left: clamp(10px, 4vw, 20px);
      padding-right: clamp(10px, 4vw, 20px);
    }

    .store-map__plot {
      width: min(calc(100% - 2 * clamp(14px, 5vw, 32px)), 100%);
    }

    .store-grid {
      gap: 6px;
    }
  }
</style>
